import i18n from '@/lang'

export function getOtaConfig() {
    return {
        // 智能运维-设备升级-一级页面进入弹窗配置项-不做翻译
        confirmConfig: {
            title: "提示",
            message: `<div>此页面即将停用。客户设备升级请前往<span style="font-weight:600">正式服OTA</span>升级，测试固件请在测试服操作。</div>`,
            confirmButtonText: "立即前往",
            cancelButtonText: '取消',
            redirect: '/otaUpgrade/firmwareManagement/inverter',
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true,
        },
        collectorCanNottUpgradeReasonOptions: [
            {label: i18n.global.t('v2_datalogger_version_not_supported'), value: 'needUp'},
            {label: i18n.global.t('v2_device_in_use'), value: 'upIng'},
            {label: i18n.global.t('v2_no_upgradeable_firmware'), value: 'noFirmware', label2: i18n.global.t('v2_device_version_not_supported_stay_tuned'),},
            {label: i18n.global.t('v2_datalogger_not_supported'), value: 'noSupport'},
        ],
        // canNotUpdateReasonTypeOptions : [//不可升级原因枚举
        //     {label: i18n.global.t('v2_ota_user_has_not_confirmed_within_the_specified_time'), value: 0},
        //     {label: i18n.global.t('v2_ota_model_number_does_not_match'), value: 1},
        //     {label: i18n.global.t('v2_ota_the_device_is_offline_within_the_specified_time'), value: 2},
        //     {label: i18n.global.t('v2_ota_inconsistent_version_numbers'), value: 3},
        //     {label: i18n.global.t('v2_ota_the_device_already_has_incomplete_upgrade_tasks'), value: 4},
        //     {label: i18n.global.t('v2_ota_firmware_has_been_removed'), value: 5},
        //     {label: i18n.global.t('v2_ota_the_upgrade_conditions_have_not_been_met'), value: 6},
        //     {label: i18n.global.t('v2_ota_upgrade_command_failed_to_be_issued'), value: 7},
        //     {label: i18n.global.t('v2_ota_there_is_an_epm_under_the_same_datalogger'), value: 8},
        //     {label: i18n.global.t('v2_ota_incorrect_device_sn'), value: 9},
        //     {label: i18n.global.t('v2_ota_three_elements_are_missing'), value: 10},
        //     {label: i18n.global.t('v2_ota_port_occupied'), value: 11},
        //     {label: i18n.global.t('v2_ota_datalogger_version_problem'), value: 19},//采集器版本为问题版本
        //     {label: i18n.global.t('v2_ota_exceeds_the_effective_length_of_the_task'), value: 20},//超过任务有效时长
        //     {label: i18n.global.t('v2_ota_device_connection_interrupted'), value: 21},//设备连接中断，请稍后重试
        //     {label: i18n.global.t('v2_ota_not_supporting_same_version_upgrade'), value: 22},//不支持同版本升级
        //     { label: i18n.global.t('v2_ota_user_cancels_upgrade'), value: 23 },//用户取消升级
        //     { label: i18n.global.t('v2_inverter_details_remote_upgrades_15_digit'), value: 25 },//2020年前15位序列号的储能设备不支持远程升级
        //     {label: i18n.global.t('v2_ota_firmware_type_not_supported'), value: 26},//固件类型不支持
        //     { label: i18n.global.t('v2_ota_upgraded_version_not_found'), value: 27 },//未查询到升级后版本
        //     { label: i18n.global.t('v2_ota_gen_3_upgrade'), value: 28 },//采集器类型或版本不支持三代升级
        //     { label: i18n.global.t('v2_ota_upgrade_protocol_not_supported'), value: 30 },//升级协议不支持
        //     { label: i18n.global.t('v2_ota_firmware_not_supported'), value: 31 },//采集器不支持此固件
        // ],
        otaUpdradeDeviceTypeConfigOptions: [
            {
                label: i18n.global.t('v2_device_datalogger'),
                deviceType: 'collector',
                value: 0,
                group: "C",
            },
            {
                label: i18n.global.t('v2_device_inverter'),
                deviceType: 'inverter',
                value: 1,
                group: "I"
            },
            {
                label: "EPM",
                deviceType: 'epm',
                value: 2,
                group: "E",
            },
            {
                label: i18n.global.t("v2_ota_aggregated_upgrade"),
                deviceType: 'bigPackage',
                value: 4,
                group: "I",
                singleLabel: i18n.global.t("v2_ota_aggregated_upgrade"), // 设备类型- 自动设备软件更新弹窗展示成”逆变器“
            },
            {
                label: i18n.global.t("v2_plant_details_battery"),//电池
                deviceType: 'battery',
                value: 6,
                group: "BATTERY",// type: 117 =》content
            },
            {
                label: i18n.global.t("v2_rapid_shutdown"),//光伏关断器
                deviceType: 'rsd',
                value: 7,
                group: "RSD",
            },
            {
                label: "EMS",//EMS
                deviceType: 'ems',
                value: 8,
                group: "EMS",
            },
        ],
        // 支持ECN编号类型
        supportECNDeviceTypeList: [0, 1, 2],
        // isVerifyOptions : [
        //     { label: i18n.global.t('v2_global_no'), value: 1 },
        //     { label: i18n.global.t('v2_global_yes'), value: 0 }
        // ],
        // upgradeStateOptions : [ //升级状态 枚举
        //     {label: i18n.global.t('v2_upgrade_record_to_be_upgraded'), value: -1},//待升级
        //     {label: i18n.global.t('v2_upgrade_record_to_be_upgraded'), value: 0},//待升级
        //     {label: i18n.global.t('v2_firmware_info_upgrading'), value: 1},//升级中
        //     {label: i18n.global.t('v2_firmware_info_upgrade_successful'), value: 2},//升级成功
        //     {label: i18n.global.t('v2_firmware_info_upgrade_failed'), value: 4},//升级失败
        //     {label: i18n.global.t('v2_extended_warranty_cancelled'), value: 3},//已取消
        //     { label: i18n.global.t('v2_upgrade_record_non_upgradable'), value: 7 },//不可升级
        //     {label: i18n.global.t('v2_ota_status_unknown'), value: 8},//状态未知
        //     {label: i18n.global.t('v2_ota_skip_upgrade'), value: 9},//无需升级
        // ],
        // upgradeNoticeOptions : [//用户确认 枚举
        //     {label: i18n.global.t('v2_upgrade_record_not_operated'), value: 1},//未操作
        //     {label: i18n.global.t('v2_upgrade_record_upgrade_now'), value: 2},//立即升级
        //     {label: i18n.global.t('v2_plant_mine_upgrade_later'), value: 3},//预约升级
        //     {label: i18n.global.t('v2_org_yijvjue'), value: 4},//已拒绝
        // ],
        // otaValidate0to9Number: (rule, value, callback) => {
        //     if (value && !/^[0-9]+$/.test(value)) {
        //         callback(i18n.global.t("v2_task_management_please_enter_numbers"));
        //     } else {
        //         callback();
        //     }
        // },
        // otaMenuOptions: [
        //   {label: i18n.global.t('v2_device_inverter'), value: "inverter"},
        //   {label: i18n.global.t('v2_device_datalogger'),value: "collector"},
        //   {label: "EPM",value: "epm"},
        //   {label: "BMS",value: "bms"},
        //   {label: i18n.global.t('v2_ota_aggregated_upgrade'),value: "bigPackage"},
        //   {label: i18n.global.t('v2_plant_details_battery'),value: "battery"},
        // ],
        // // ota任务提醒类型
        // otaTaskNoticeTypeOptions: [
        //     {label: i18n.global.t('v2_firmware_management_upgrade_automatically_after_user_confirmation'), value: 2},
        //     {label: i18n.global.t('v2_firmware_management_upgrade_manually'), value: 1},
        //     {label: i18n.global.t('v2_firmware_management_automatic_upgrade_without_user_confirmation'), value: 0}
        // ],
        // // ota任务状态
        // otaTaskStateOptions: [
        //     {label: i18n.global.t('v2_task_management_to_be_submitted'), value: 0},//待提交
        //     {label: i18n.global.t('v2_ota_to_be_implemented'), value: 2},//待执行
        //     {label: i18n.global.t('v2_equipment_upgrade_in_progress'), value: 3},//进行中
        //     {label: i18n.global.t('v2_ota_suspended'), value: 4},//已暂停
        //     {label: i18n.global.t('v2_extended_warranty_cancelled'), value: 5},//已取消
        //     {label: i18n.global.t('v2_ota_ended'), value: 6},//已结束
        // ],
         // 预约时间00:00~23:00
        scheduledTimeList:  Array.from({length: 24}, (_, i) =>
         `${i.toString().padStart(2, '0')}:00`
        )
    }
}
// 获取设备的配置
export const getDeviceTypeConfig = (deviceType) => {
    let deviceTypeStr = ""
    const isNumber = typeof deviceType  === 'number'
    if(!isNumber) deviceTypeStr =  deviceType
    const options = getOtaConfig().otaUpdradeDeviceTypeConfigOptions
    const info = options.find(item => deviceTypeStr ? item.deviceType === deviceTypeStr : item.value === deviceType) || {}
    return {
        ...info,
        equipmentType: info.group,
        deviceType: info.value
    }
}
